import { GenericHeader } from "../../utility/common/TransactionComponents/Generic_WPQ_WPS_PQR_header"; // USED

// USED - Exported and imported in 3 files: WeldingProcedure.jsx, WeldingProcedureSpec.jsx, WPSTubesheetProcedureSpec.jsx
export const WPSHeader = ({ headerObj }) => {
  // USED - Passed to GenericHeader component
  const headerData = [
    { label: "Project No.", value: headerObj.WPSH_Project_No }, // USED - Widely used across 70+ files
    { label: "WPS No.", value: headerObj.WPSH_WPS_No }, // USED - Widely used across codebase
    { label: "WPS Revision No.", value: headerObj.WPSH_WPS_Revi_No }, // USED - Used in multiple files
    { label: "WPS Date", value: headerObj.WPSH_WPS_Date }, // USED - Used in multiple files
    { label: "Supporting PQR", value: headerObj.WPSH_SupportingPQR } // USED - Used in multiple files
  ];

  return <GenericHeader headerData={headerData} />;
};